import { nest } from "recompose";

import styled from "styled-components/macro";

const Container = styled.div`
  overflow: auto;
  width: 100%;
`;

const Content = styled.div`
  max-width: ${props => (props.fullWidth ? "" : "1200px")};
  margin: 0 auto;
`;

export default nest(Container, Content);
